<!-- toggle-dropdown.component.html -->
<div class="dropdown" *ngIf="text === 'Filter'">
    <button
        class="btn custom-dropdown-btn dropdown-toggle d-flex justify-content-between align-items-center"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        [disabled]="true"
    >
        <div class="d-flex align-items-center">
            <img [src]="iconSrc" alt="Dropdown Icon" class="icon" />
            <span class="ms-2">{{ text }}</span>
        </div>
        <img src="../../../../assets/organisation/icon-chevron-down.svg" />
    </button>
    <ul #dropdownMenu class="dropdown-menu custom-dropdown-menu filter" aria-labelledby="dropdownMenuButton" (click)="$event.stopPropagation()">
        <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectFilter('7')">Last 7 Days</a>
        </li>
        <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectFilter('30')">Last 30 Days</a>
        </li>
        <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectFilter('2024')">This Year (2024)</a>
        </li>
        <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectFilter('2023')">Last Year (2023)</a>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
            <div class="dropdown-item">
                <div class="sub-head-s2">By Search</div>
                <div class="input-group form-group position-relative my-2">
                    <input type="text" placeholder="Search" class="form-control text-black mt-1" />
                </div>
                <div class="mb-"></div>
            </div>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
            <div class="dropdown-item">
                <div class="sub-head-s2 mb-2">By Date</div>
                <div class="align-items-center filterByDateGroup">
                    <form [formGroup]="filterByDateGroup" class="d-flex flex-wrap align-items-center w-100">
                        <div class="dateFilterInput col-auto position-relative pr-1">
                            <input type="date" class="form-control form-control-option" name="dateFieldFrom" formControlName="dateFieldFrom" (change)="valueAdded($event)" />
                            <span class="calendar-icon">
                                <img src="../../../../assets/organisation/icon-calendar.svg" alt="Calendar Icon" title="Calendar Icon" />
                            </span>
                        </div>
                        <!-- <span class="to-class col-auto">To</span>  -->
                        <div class="dateFilterInput col-auto position-relative pl-1">
                            <input type="date" class="form-control form-control-option" name="dateFieldTo" formControlName="dateFieldTo" (change)="valueAdded($event)" />
                            <span class="calendar-icon">
                                <img src="../../../../assets/organisation/icon-calendar.svg" alt="Calendar Icon" title="Calendar Icon" />
                            </span>
                        </div>
                    </form>
                </div>
                <div class="dataRangeBtn mt-3">
                    <button type="button" class="btn btn-dateAction" (click)="searchByDate()">Apply</button>
                    <button type="button" class="btn btn-dateAction" (click)="clearDate()">Reset</button>
                </div>
            </div>
        </li>
    </ul>
</div>

<div class="dropdown" *ngIf="text === 'Sort'">
    <button
        class="btn custom-dropdown-btn dropdown-toggle d-flex justify-content-between align-items-center"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        [disabled]="false"
        [attr.id]="'go-sort-dropdown-btn'"
        [attr.data-test]="'go-sort-dropdown-btn'"
    >
        <div class="d-flex align-items-center">
            <img [src]="iconSrc" alt="Dropdown Icon" class="icon" />
            <span class="ms-2">{{ text }}</span>
        </div>
        <!-- <i class="bi bi-caret-down"></i> -->
        <img src="../../../../assets/organisation/icon-chevron-down.svg" />
    </button>
    <ul #dropdownMenu class="dropdown-menu custom-dropdown-menu sort" aria-labelledby="dropdownMenuButton" (click)="$event.stopPropagation()">
        <li>
            <div class="sub-head-s2 dropdown-item">
                <strong>By Date</strong>
            </div>
            <form [formGroup]="sortByDateGroup">
                <div class="d-flex dropdown-item-group">
                    <div>
                        <input
                            type="radio"
                            value="asc"
                            name="sortByDate"
                            formControlName="sortByDate"
                            (change)="setSortByDate($event)"
                            [attr.id]="'go-sort-sortByDate-asc-input'"
                            [attr.data-test]="'go-sort-sortByDate-asc-input'"
                        />
                    </div>
                    <div class="mtl-3p dropdown-item-group-text">Ascending</div>
                </div>
                <div class="d-flex dropdown-item-group">
                    <div>
                        <input
                            type="radio"
                            value="desc"
                            name="sortByDate"
                            formControlName="sortByDate"
                            (change)="setSortByDate($event)"
                            [attr.id]="'go-sort-sortByDate-desc-input'"
                            [attr.data-test]="'go-sort-sortByDate-desc-input'"
                        />
                    </div>
                    <div class="mtl-3p dropdown-item-group-text">Descending</div>
                </div>
            </form>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
            <div class="sub-head-s2 dropdown-item">
                <strong>By Name</strong>
            </div>
            <form [formGroup]="sortByNameGroup">
                <div class="d-flex dropdown-item-group">
                    <div>
                        <input
                            type="radio"
                            value="asc"
                            name="sortByName"
                            formControlName="sortByName"
                            (change)="setSortByName($event)"
                            [attr.id]="'go-sort-sortByName-az-input'"
                            [attr.data-test]="'go-sort-sortByName-az-input'"
                        />
                    </div>
                    <div class="mtl-3p dropdown-item-group-text">A-Z</div>
                </div>
                <div class="d-flex dropdown-item-group">
                    <div>
                        <input
                            type="radio"
                            value="desc"
                            name="sortByName"
                            formControlName="sortByName"
                            (change)="setSortByName($event)"
                            [attr.id]="'go-sort-sortByName-za-input'"
                            [attr.data-test]="'go-sort-sortByName-za-input'"
                        />
                    </div>
                    <div class="mtl-3p dropdown-item-group-text">Z-A</div>
                </div>
            </form>
        </li>
        <li>
            <div class="dropdown-item">
                <div class="dataRangeBtn">
                    <button type="button" class="btn btn-dateAction" (click)="applySort($event)" [attr.id]="'go-sort-apply-btn'" [attr.data-test]="'go-sort-apply-btn'">
                        Apply
                    </button>
                    <button type="button" class="btn btn-dateAction" (click)="clearSort()" [attr.id]="'go-sort-reset-btn'" [attr.data-test]="'go-sort-reset-btn'">Reset</button>
                </div>
            </div>
        </li>
    </ul>
</div>
